export default {
  registration: {
    header: {
      // title: "",
      // title_esg_data_share: '',
    },
    passcode: {
      section_one: 'Diese Registrierungsseite ist speziell für Unternehmen gedacht, die Sie zur Nutzung dieses Dienstes aufgefordert haben.',
      section_two: 'Bitte geben Sie einen Passcode ein, um zur Registrierungsseite zu gelangen.',
      section_three: 'Wenn Sie keinen Passcode erhalten haben, wenden Sie sich bitte an das Unternehmen, das Sie zur Nutzung dieses Dienstes aufgefordert hat',
      passcode: 'Passcode für die Anzeige',
      passcode_placeholder: '@:common.form.search_word.placeholder',
      incomplete_input: 'Falsche Eingabe.',
      unexpected_error: 'Ein unerwarteter Fehler ist aufgetreten',
    },
    email: {
      section_one: '@:registration.passcode.section_one',
      section_two: 'Bitte geben Sie Ihre E-Mail-Adresse ein, um sich zu registrieren.',
      email: 'E-Mail Adresse',
      email_placeholder: 'E-Mail Adresse ausfüllen',
    },
    sent: {
      section_one: 'Wir haben eine E-Mail an die von Ihnen angegebene Adresse geschickt.',
      // section_two: "",
      section_three: 'Wenn Sie innerhalb von 30 Minuten keine E-Mail erhalten haben, wenden Sie sich bitte an',
      section_four: '.',
    },
    password: {
      // TODO: section_one は日本語だと「アスエネ/アスエネESGの」を「アスエネ関連プロダクトの」に変更する対応が入っており、本言語にはそれが未反映
      section_one: 'Die von Ihnen eingegebene E-Mail-Adresse wird bereits für das ASUENE/ASUENE ESG-Konto verwendet.',
      section_two: 'Bitte melden Sie sich mit Ihrem Passwort an.',
      password: 'Passwort',
      password_placeholder: 'Bitte geben Sie Ihr Passwort ein',
      error_auth: 'Authentifizierung fehlgeschlagen. Bitte melden Sie sich erneut an',
      error_linking: 'Authentifizierung fehlgeschlagen.Bitte geben Sie das Passwort erneut ein',
      // same_domain_modal: {
      //   title: '',
      //   section: '',
      // },
    },
    info: {
      section_one: '@:registration.passcode.section_one',
      section_two: 'Bitte geben Sie die erforderlichen Informationen ein, um Ihre Registrierung abzuschließen.',
      section_three: 'Bitte melden Sie sich nach der Bewerbung mit Ihrem registrierten Konto an, damit Sie die angeforderte Umfrage beantworten können.',
      // buyer_name: "",
      expires_date: 'Verfallsdatum',
      deadline: '@:common.date.answer_expires_date',
    },
    form: {
      invalid_form: '@:settings.messages.invalid_form',
      company_name: 'Name der Firma',
      company_name_placeholder: '@:common.company_name_inc',
      company_scale: '@:settings.company.scale',
      select_placeholder: '@:upload_common.target_select',
      industry_type: '@:settings.company.industry_type',
      first_name: '@:settings.user.first_name',
      last_name_placeholder: 'Yamada',
      last_name: '@:settings.user.last_name',
      first_name_placeholder: 'Taro',
      email: '@:settings.user.email',
      email_placeholder: '@:settings.user.email',
      email_text: 'Die von Ihnen eingegebene E-Mail-Adresse wird angezeigt',
      // phone: "",
      phone_placeholder: '0000000000',
      locale: 'Sprache auswählen',
      // section_one: "",
      rule: 'Bitte stimmen Sie den Allgemeinen Geschäftsbedingungen',
      rule_link: '/pdf/241112_AsueneESG_Terms_and_Conditions_Supplier.pdf',
      punctuation: ' und der',
      policy: 'Richtlinie zum Datenschutz',
      policy_link: 'https://asuene.com/en/privacy',
      section_two: 'zu, bevor Sie fortfahren.',
      // same_domain_modal: {
      //   title: '',
      //   section: '',
      // },
    },
    thanks: {
      section_one: 'Vielen Dank für Ihre Anmeldung.',
      section_two: 'Wir haben Ihre Anmelde-ID und Ihr Passwort an die von Ihnen angegebene E-Mail-Adresse geschickt.',
      section_three: 'Bitte prüfen Sie Ihre E-Mail und folgen Sie den Anweisungen in der E-Mail, um sich einzuloggen.',
      section_four: 'Wenn Sie innerhalb von 30 Minuten keine E-Mail erhalten haben,',
      // section_five: "",
      // section_six: "",
    },
    expired: {
      section_one: 'Die angegebene URL ist bereits abgelaufen',
      section_two: 'Wenn Sie diesen Service nutzen möchten, wenden Sie sich bitte an',
      section_three: 'Der zuständige Mitarbeiter wird sich mit Ihnen in Verbindung setzen.',
    },
    error: {
      section_one: 'Die angegebene URL konnte nicht gefunden werden.',
      section_two: 'Wir entschuldigen uns für die Unannehmlichkeiten, aber bitte überprüfen Sie die URL noch einmal.',
    },
    btn: {
      submit: 'Senden',
      service_top: 'Nach oben',
      // login: "",
      register: 'Registrieren',
      rating_url: 'https://asuene.com/rating/en',
    },
    buyer: {
      // sharing_company: "",
      // explain_message: "",
    },
  },
}
